import {useState, useMemo} from "preact/compat";
import {useAppContext} from "../../../contexts";

export const useContent = () => {
    // State to store the input filter query
    const [filterQuery, setFilterQuery] = useState("");

    // All the available store locations
    const {locations, setStoreLocation} = useAppContext();

    // Memo to store the current selected location and also filter it by the filterQuery state value
    const availableLocations = useMemo(() => {
        return locations.filter(item => {
            return item?.name?.toLowerCase().includes(filterQuery.toLowerCase()) ||
                item?.regionIndex?.toLowerCase().includes(filterQuery.toLowerCase());
        })
    }, [locations, filterQuery]);

    // Method to handle the filter input value change
    const handleChange = e => {
        // Destructured props
        const {value} = e.target;

        // Sets the value to the filter query state
        setFilterQuery(value);
    }

    // Method to handle the location change
    const handleLocationChange = props => {
        try {
            // Destructured props
            const {id, name, code} = props;

            // Sets the new location to the local storage
            setStoreLocation({
                id,
                name
            });

            // Refreshes the page
            window.location.href = `${window.location.pathname}?___store=${code}`;
        } catch (e) {
            console.error(`Erro ao alterar loja: ${e}`)
        }
    }

    return {
        filterQuery,
        availableLocations,
        handleChange,
        handleLocationChange
    }
}
